export { default } from './Fade';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/Fade/index.js
// module id = 240
// module chunks = 0